import { render, staticRenderFns } from "./QuickAgent.vue?vue&type=template&id=2771dc56"
import script from "./QuickAgent.vue?vue&type=script&lang=js"
export * from "./QuickAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports